import { asKeyMapAsync } from "./asKeyMapAsync.js";
export async function* asSortedKeyValuesAsync(source, keySelector, ascending, comparer) {
    const map = await asKeyMapAsync(source, keySelector);
    const sortedKeys = [...map.keys()].sort(comparer ? comparer : undefined);
    if (ascending) {
        for (let i = 0; i < sortedKeys.length; i++) {
            yield map.get(sortedKeys[i]);
        }
    }
    else {
        for (let i = sortedKeys.length - 1; i >= 0; i--) {
            yield map.get(sortedKeys[i]);
        }
    }
}
